export const priceAlertStatuses = {
  Active: 1,
  Triggered: 2,
  Expired: 3,
};

export const priceAlertStatusTypes = Object.keys(priceAlertStatuses);
